import { Box } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import Pressable from '@/theme/Pressable'
import { useDocumentPreviewOptional } from '@/features/documentPreview/useDocumentPreview'
import {
  citationLocationLabel,
  citationLocationStatus,
  isTargetFlagged,
} from './citationLabel'
import { openCitationPreview } from './openCitationPreview'
import { citationMarkerSx } from './citationMarkerSx'

export default function CitationMarker({ marker, citation, targetIndex = -1 }) {
  const preview = useDocumentPreviewOptional()
  const flagged = isTargetFlagged(citation, targetIndex)
  const location = citationLocationLabel(citation, targetIndex)
  const locationStatus = citationLocationStatus(citation, targetIndex)

  return (
    <Tooltip
      text={locationStatus ? `${location} - ${locationStatus}` : location}
      placement="top"
    >
      <Pressable
        as="button"
        aria-label={`Source ${marker}: ${location}${locationStatus ? `, ${locationStatus}` : ''}`}
        onClick={() => openCitationPreview(preview, citation, targetIndex)}
        sx={citationMarkerSx(flagged)}
      >
        {marker}
        {flagged ? (
          <Box component="span" sx={{ ml: '1px' }} aria-hidden>
            !
          </Box>
        ) : null}
      </Pressable>
    </Tooltip>
  )
}
